import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { useGlobalContext } from "../../context";
import { useLocation, Link } from "react-router-dom";
import FadeOnScreen from "../../utils/fadeOnScreen";
import localData from "../../localData";
import { Button } from "../../components";

export default function WhatWeDo() {
    const { fade } = useGlobalContext().animations;

    const location = useLocation();

    const { whatWeDoIcon, waves2, prolog } = localData.images;
    const { marketing, architecture, planning, development } = localData.svgs;

    useEffect(() => FadeOnScreen.createObserver(), [location]);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return (
        <motion.main {...fade} className="what-we-do-page">
            <section className="showcase">
                <img className="what-we-do-cover" src={waves2} alt="" />
                <div className="container info-container">
                    <div className="showcase-icon">
                        <img src={whatWeDoIcon} alt="" />
                    </div>
                    <div className="showcase-title-wrapper">
                        <h2 className="showcase-title display-1">Our Approach</h2>
                    </div>
                    <h3 className="showcase-subtitle">True Advertising is based on finding the ideal customer.</h3>
                    <p className="showcase-description">
                        We get it. You are not here to hear about us, you want to know what we can do for your business.
                        It’s difficult finding the right marketing agency willing to go the extra mile to understand
                        your market and create solutions tailor-made for your business needs.
                    </p>
                    <div className="wrapper">
                        <Link to="/contact">
                            <Button className="btn btn-lg btn-outline-light contact-btn">
                                <p>work with experts</p>
                            </Button>
                        </Link>
                    </div>
                </div>

                <div className="container">
                    <div className="showcase-center">
                        <div className="wrapper">
                            <div className="prolog" data-lazy-block>
                                <h3 className="prolog-title">what we do</h3>
                                <img className="prolog-image" src={prolog} alt="" data-lazy="scale" />
                            </div>
                        </div>
                        <div className="card-group">
                            <div className="wrapper" data-lazy-block>
                                <Link to="#/" className="card what-we-do-card" data-lazy="fade-up">
                                    <div className="card-icon">{marketing}</div>
                                    <h4 className="card-title">Integrated Marketing Strategy and Planning</h4>
                                    <div className="card-description">
                                        Based on our market research, we help you analyse your competitors, design your
                                        business strategy, capabilities, processes and metrics. Then we map out your
                                        ideal market, define a winning value proposition and create a strategy to help
                                        you win in the market and achieve your goals
                                    </div>
                                </Link>
                            </div>
                            <div className="wrapper" data-lazy-block>
                                <Link to="#/" className="card what-we-do-card" data-lazy="fade-up">
                                    <div className="card-icon">{architecture}</div>
                                    <h4 className="card-title">Brand Architecture and Identity Development</h4>
                                    <div className="card-description">
                                        Just like every building needs a foundation, every business a brand
                                        architecture. Are you a new business or looking to rebrand, we provide clarity
                                        around your products and services, creating a framework to organize your
                                        offerings, develop a unique brand identity, and gain brand equity. From your
                                        messaging to your design, we ensure there is a consistency that drives recall
                                        and creates overall value for your brand.
                                    </div>
                                </Link>
                            </div>
                            <div className="wrapper" data-lazy-block>
                                <Link to="#/" className="card what-we-do-card" data-lazy="fade-up">
                                    <div className="card-icon">{planning}</div>
                                    <h4 className="card-title">Campaign Planning and Execution</h4>
                                    <div className="card-description">
                                        Great campaigns are inspired by powerful consumer insights. Based on research,
                                        we create memorable and inspiring campaigns that cut through the noise, creates
                                        an emotional experience with your customers and achieve results. We handle the
                                        end to end process from Copywriting, Design, Photography, videography, to Media
                                        buying, Tracking and Analytics.
                                    </div>
                                </Link>
                            </div>
                            <div className="wrapper" data-lazy-block>
                                <Link to="#/" className="card what-we-do-card" data-lazy="fade-up">
                                    <div className="card-icon">{development}</div>
                                    <h4 className="card-title">Web Development</h4>
                                    <div className="card-description">
                                        We take a strategic approach to website design. We focus on communicating your
                                        value proposition with clear messaging and out of the box design that attracts,
                                        resonates with the right audience and boosts engagement., ensuring that visitors
                                        take a action that moves them from prospects to customers. We create custom
                                        WordPress designs, Custom redesigns, responsive web design, UX/UI design,
                                        Shopify web design, designs for corporate blog
                                    </div>
                                </Link>
                            </div>
                        </div>

                        <div className="wrapper">
                        <Link to="/contact">
                            <Button className="btn btn-lg btn-outline-light contact-btn">
                                <p>work with experts</p>
                            </Button>
                        </Link>
                        </div>
                    </div>
                </div>
            </section>
        </motion.main>
    );
}
